import i18n from 'i18next';

export const VIEW_STATUS = {
  get CREATED() {
    return i18n.t('common_order_status_created');
  },
  get REJECTED() {
    return i18n.t('common_order_status_rejected');
  },
  get OPEN() {
    return i18n.t('common_order_status_open');
  },
  get PARTIALLY_FILLED_OPEN() {
    return i18n.t('common_order_status_open_partially_filled');
  },
  get COMPLETED() {
    return i18n.t('common_order_status_completed');
  },
  get PARTIALLY_FILLED_CLOSED() {
    return i18n.t('common_order_status_closed_partially_filled');
  },
  get CLOSED() {
    return i18n.t('common_order_status_closed');
  }
};
